


export class RetrieveBookingContext {

    public routeTo: string[] = [];
    constructor() {

    }
}